module.exports = __webpack_public_path__ + "static/media/ABL Workspaces.405ee463.webp";